export class FinancialStatementViewItem {
  private date: Date;
  private networkName: string;
  private productQuantity: number;
  private networkFiscalNumber: string;
  private produtoName: string;
  private ean: string;
  private discountValue: number;
  private employmentPayrollValue: number;
  private price: number;
  private unitPrice: number;
  private subsidyValue: number;
  private salesAction: string;
  private beneficiaryName: string;
  private beneficiarySocialNumber: string;

  setBeneficiarySocialNumber(value: string): void {
    this.beneficiarySocialNumber = value;
  }
  
  getBeneficiarySocialNumber(): string {
    return this.beneficiarySocialNumber;
  }

  setBeneficiaryName(value: string): void {
    this.beneficiaryName = value;
  }

  getBeneficiaryName(): string {
    return this.beneficiaryName;
  }

  setDate(value: Date): void {
    this.date = value;
  }

  getDate(): Date {
    return this.date;
  }

  setNetworkName(value: string): void {
    this.networkName = value;
  }

  getNetworkName(): string {
    return this.networkName;
  }

  setNetworkFiscalNumber(value: string): void {
    this.networkFiscalNumber = value;
  }

  getNetworkFiscalNumber(): string {
    return this.networkFiscalNumber;
  }

  setProductName(value: string): void {
    this.produtoName = value;
  }

  getProductName(): string {
    return this.produtoName;
  }

  setEmploymentPayrollValue(value: number): void {
    this.employmentPayrollValue = value;
  }

  getEmploymentPayrollValue(): number {
    return this.employmentPayrollValue;
  }

  setPrice(value: number): void {
    this.price = value;
  }

  getPrice(): number {
    return this.price;
  }

  setSubsidyValue(value: number): void {
    this.subsidyValue = value;
  }

  getSubsidyValue(): number {
    return this.subsidyValue;
  }

  setDiscountValue(value: number): void {
    this.discountValue = value;
  }

  getDiscountValue(): number {
    return this.discountValue;
  }

  setUnitPrice(value: number): void {
    this.unitPrice = value;
  }

  getUnitPrice(): number {
    return this.unitPrice;
  }

  setproductQuantity(value: number): void {
    this.productQuantity = value;
  }

  getProductQuantity(): number {
    return this.productQuantity;
  }

  setEan(value: string): void {
    this.ean = value;
  }

  getEan(): string {
    return this.ean;
  }

  setSalesAction(value: string): void {
    this.salesAction = value;
  }

  getSalesAction(): string {
    return this.salesAction;
  }
}
